var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-item',{attrs:{"link":{
    id: _vm.menuModule.id,
    name: _vm.translateDataBaseText(_vm.menuModule.name, _vm.menuModule.other_value),
    icon: _vm.menuModule.icon,
    path: '/' + _vm.menuModule.url,
    icon_right: _vm.menuModule.icon_right,
  }},on:{"dashLoading":_vm.dashLoading,"load-icon-content":_vm.loadIconContent}},_vm._l((_vm.getLevelTwoModules(_vm.menuModule.children)),function(mod,index){return _c('sidebar-item',{key:index,attrs:{"link":{
      id: mod.id,
      name: _vm.translateDataBaseText(mod.name, mod.other_value),
      icon: mod.icon,
      path: '/' + mod.url,
      icon_right: _vm.menuModule.icon_right,
    }},on:{"dashLoading":_vm.dashLoading,"load-icon-content":_vm.loadIconContent}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }